import { render, staticRenderFns } from "./ModalChangeNumber.vue?vue&type=template&id=05b80d31"
import script from "./ModalChangeNumber.vue?vue&type=script&lang=js"
export * from "./ModalChangeNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports